import { IServices } from "@netent/origin";
import { ILanguageOptions, IPlayUIState } from "@netent/playui";
import { Store } from "redux";
import { IStoreAction, IStoreState } from "../store";

export const updateView = (
  store: Store<IStoreState, IStoreAction>
): IPlayUIState => ({ view: store.getState().view });

export const setPlayForFunIndicatorEnabled = (
  enabled: boolean
): IPlayUIState => ({
  playForFunIndicator: {
    enabled
  }
});

export const getLanguage = (services: IServices): ILanguageOptions => {
  const t = (key: string) => services.language.getText(key);

  return {
    AutoplaySettingsSubTitle: t("OCTchooseAutoplayStopConditions"),
    AutoplaySettingsTitle: t("OCTadvancedSettings"),
    AutoplaySubTitle: t("OCTchooseAutoplayRounds"),
    AutoplayTitle: t("OCTautoplayPanelLabel"),
    Balance: t("OCTbalance"),
    Bet: t("OCTmachinetext_bet"),
    BetSettingsCashTitle: t("OCTmachinetext_bet"),
    BetSettingsCoinsTitle: t("OCTcoinValue"),
    Coins: t("OCTmachinetext_coins"),
    CoinValue: t("OCTcoinValue"),
    FreeRoundsLeft: t("OCTroundsLeft"),
    FreeSpins: t("OCTfreeSpinsUC"),
    GameClientVersion: t("OCTgameClientVersion"),
    GameHistoryButton: t("OCTopen"),
    GameHistoryDescriptionAvailable: t("OCTgameHistoryNewTab"),
    GameHistoryDescriptionUnavailable: t("OCThistoryNotAvailable"),
    GameHistoryTitle: t("OCTgameHistory"),
    GameRulesButton: t("OCTopen"),
    GameRulesDescription: t("OCTgameRulesNewTab"),
    GameRulesTitle: t("OCTgameRulesUC"),
    GameSettingsTitle: t("OCTslidePanelLabel"),
    GameServerVersion: t("OCTgameServerVersion"),
    Level: t("OCTlevel"),
    MaxBet: t("OCTmaxBet"),
    MinBet: t("OCTminBet"),
    PaytableTitle: t("OCTbutton_paytableUC"),
    PlayingForFun: t("OCTplayingForFun"),
    Required: t("OCTrequired"),
    Reset: t("OCTreset"),
    TotalWin: t("OCTTotalWinSingleUC"),
    Win: t("OCTWin")
  };
};
